import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './store';

export interface FilterState {
  [key: string]: string[];
}

const initialState: FilterState = {};

export const filterSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setFilter: (
      state,
      action: PayloadAction<{ key: string; value: string[] }>,
    ) => {
      state[action.payload.key] = action.payload.value;
    },
    clearPageFilters: (state, action: PayloadAction<{ page: string }>) => {
      const pagePrefix = `${action.payload.page}-`;
      for (const key in state) {
        if (key.startsWith(pagePrefix)) {
          delete state[key];
        }
      }
    },
  },
});

export const { setFilter, clearPageFilters } = filterSlice.actions;

export const selectAllFilters = (state: RootState) => state.filters;

export default filterSlice.reducer;